import React from 'react'

function AngrySmiley ({ className, fill }) {
  return (
    <svg fill={fill} className={className} viewBox='0 0 336 336'>
      <circle class='cls-1' cx='104' cy='136' r='8' />
      <circle class='cls-1' cx='232' cy='136' r='8' />
      <path class='cls-1' d='M168,0A168,168,0,1,0,336,168,168,168,0,0,0,168,0ZM80,136a24,24,0,1,1,24,24A24,24,0,0,1,80,136ZM245.34,254a8,8,0,0,1-11.3-.62,89,89,0,0,0-132.08,0A8,8,0,0,1,90,242.66a105,105,0,0,1,155.92,0A8,8,0,0,1,245.34,254ZM232,160a24,24,0,1,1,24-24A24,24,0,0,1,232,160Z' />
    </svg>
  )
}

AngrySmiley.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default AngrySmiley
